import { useGetPerson } from '@my-pages/hooks/useGetPerson.ts';

interface IContactFormProps {
    openForm: () => void;
}
const ContactInformation = ({ openForm }: IContactFormProps) => {
    const person = useGetPerson();
    return (
        <div>
            <div className='ft-table ft-responsive-sm table-mark-empty font-size-sm'>
                <div className='ft-tbody'>
                    <div className='ft-tr'>
                        <div className='ft-th'>Förnamn</div>
                        <div className='ft-td'>{person?.firstName}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>Efternamn</div>
                        <div className='ft-td'>{person?.lastName}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>E-postadress</div>
                        <div className='ft-td'>{person?.email}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>Mobiltelefon</div>
                        <div className='ft-td'>{person?.mobilePhone}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>Hemtelefon</div>
                        <div className='ft-td'>{person?.phone}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>Adress</div>
                        <div className='ft-td'>{person?.addresses && person.addresses[0] ? (person.addresses[0].street ?? '') : ''}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>Adressrad 2</div>
                        <div className='ft-td'>{person?.addresses && person.addresses[1] ? (person.addresses[1].street ?? '') : ''}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>C/o adress</div>
                        <div className='ft-td'>{person?.addresses && person.addresses[0] ? (person.addresses[0].careOf ?? '') : ''}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>Postnummer</div>
                        <div className='ft-td'>{person?.addresses && person.addresses[0] ? (person.addresses[0].zipCode ?? '') : ''}</div>
                    </div>
                    <div className='ft-tr'>
                        <div className='ft-th'>Postort</div>
                        <div className='ft-td'>{person?.addresses && person.addresses[0] ? (person.addresses[0].city ?? '') : ''}</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-sm-end my-4'>
                <button
                    className='btn btn-outline-primary'
                    type='button'
                    onClick={() => openForm()}
                >
                    Ändra
                </button>
            </div>
        </div>
    );
};

export default ContactInformation;
